import types from '@/vuex/ui/actions-types'

const actions = {
  [types.SHOW_GLOBAL_LOADING]: ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, payload)
  },
  [types.HIDE_GLOBAL_LOADING]: ({ commit }) => {
    commit(types.HIDE_GLOBAL_LOADING)
  },
  [types.SHOW_SNACKBAR]: ({ commit }, payload) => {
    commit(types.SHOW_SNACKBAR, payload)
  },
  [types.HIDE_SNACKBAR]: ({ commit }) => {
    commit(types.HIDE_SNACKBAR)
  },
  [types.SHOW_CONFIRMATION_DIALOG]: ({ commit }, payload) => {
    commit(types.SHOW_CONFIRMATION_DIALOG, payload)
  },
  [types.HIDE_CONFIRMATION_DIALOG]: ({ commit }) => {
    commit(types.HIDE_CONFIRMATION_DIALOG)
  },
  [types.SET_MENSAGEM]: ({ commit }, payload) => {
    commit(types.SET_MENSAGEM, payload)
  },
  [types.SHOW_MENSAGEM]: ({ commit }, payload) => {
    commit(types.SHOW_MENSAGEM)
  },
  [types.HIDE_MENSAGEM]: ({ commit }, payload) => {
    commit(types.HIDE_MENSAGEM)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/ui/actions.js